import {ToastType, toast, setDefaults} from 'bulma-toast';

setDefaults({
  duration: 5000,
  position: 'top-right',
});

const showNotification = (message: string, type: ToastType): void => {
  toast({
    message,
    type,
    dismissible: true,
  });
};

export const showSuccessNotification = (message: string): void => showNotification(message, 'is-success');

export const showErrorNotification = (message: string): void => showNotification(message, 'is-danger');

